<i18n src="./../../i18n/main_map.json"></i18n>

<template>
    <div id="mt-contact-section" class="container-fluid mt-map-container">
        <div v-if="locale !== 'lt'" class="row no-gutters pt-5 pb-5">
            <div class="col-lg-7">
                <google-map-loader :scale="mapScale" :zoom="mapZoom" :position-x="latitude" :position-y="longitude"/>
            </div>
            <div class="col-lg-5 mt-location-container p-5">
                <div class="row">
                    <div class="col pb-2">
                        <h3 v-text="$t('departments')"/>
                    </div>
                </div>
                <div class="row item">
                    <main-map-item v-for="item in mapData"
                                   :key="item.address"
                                   :item-data="item"/>
                </div>
            </div>
        </div>
        <div v-else class="row no-gutters pt-5 pb-5">
            <div class="col-lg-12">
                <google-map-loader :scale="mapScale" :zoom="mapZoom" :position-x="latitude" :position-y="longitude"/>
            </div>
        </div>
    </div>
</template>

<script>
    import GoogleMapLoader from "@/components/commons/GoogleMapLoader";
    import MainMapItem from "@/components/commons/MainMapItem";
    import {Const} from "@/main";
    export default {
        name: "MainMap",
        components: {MainMapItem, GoogleMapLoader},
        props: {
            mapData: Array
        },
        data() {
            return {
                locale: this.$i18n.locale,
                latitude: Const.GOOGLE_MAPS_CENTER_LATITUDE,
                longitude: Const.GOOGLE_MAPS_CENTER_LONGITUDE,
                mapScale: Const.GOOGLE_MAPS_SCALE,
                mapZoom: Const.GOOGLE_MAPS_ZOOM,
            }
        }
    }
</script>

<style scoped>
    .mt-map-container {
        background: linear-gradient(90deg, #e5f3ff 25%, #122840 25%);
    }

    .mt-location-container {
        background-color: #fff;
    }

    #mt-contact-section .row.item {
        cursor: pointer;
    }
</style>